<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[800px]" style="height: 590px; overflow-y: auto;">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>Examination Instruction for {{exam.examinationName}}</h5>
    <label class="form-label mt-2">Instruction</label>
    <div class="mb-3 mr-0 col-md-12">

      <quill-editor #editor [(ngModel)]="examInstruction.instructions" name="message" >
      </quill-editor>
    </div>
    <button class="btn btn-primary btn-lg col-md-12x" type="submit"
      [disabled]="!exam || !examInstruction.instructions" (click)="saveInstruction()">
      Save Instruction
    </button>
  </div>
</div>